/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 1xLhJbx5VveCXJsMYNxtFb
// Component: 0fErs5Rt_giR
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  hasVariant,
  renderPlasmicSlot,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/styleTokensProvider
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic.module.css"; // plasmic-import: 1xLhJbx5VveCXJsMYNxtFb/projectcss
import sty from "./PlasmicTopnav.module.css"; // plasmic-import: 0fErs5Rt_giR/css

createPlasmicElementProxy;

export const PlasmicTopnav__VariantProps = new Array("layoutType");

export const PlasmicTopnav__ArgProps = new Array("pageTitle", "pageButtons");

const $$ = {};

function PlasmicTopnav__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "layoutType",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.layoutType
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  const styleTokensClassNames = _useStyleTokens();
  return (
    <div
      data-plasmic-name={"topnav"}
      data-plasmic-override={overrides.topnav}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        styleTokensClassNames,
        sty.topnav,
        {
          [sty.topnavlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        }
      )}
    >
      <div
        data-plasmic-name={"pageTitleSlot"}
        data-plasmic-override={overrides.pageTitleSlot}
        className={classNames(projectcss.all, sty.pageTitleSlot, {
          [sty.pageTitleSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.pageTitleSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.pageTitle
        })}
      </div>
      <div
        data-plasmic-name={"topnavButtonsSlot"}
        data-plasmic-override={overrides.topnavButtonsSlot}
        className={classNames(projectcss.all, sty.topnavButtonsSlot, {
          [sty.topnavButtonsSlotlayoutType_justTitle]: hasVariant(
            $state,
            "layoutType",
            "justTitle"
          ),
          [sty.topnavButtonsSlotlayoutType_titleButtons]: hasVariant(
            $state,
            "layoutType",
            "titleButtons"
          )
        })}
      >
        {renderPlasmicSlot({
          defaultContents: null,
          value: args.pageButtons
        })}
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  topnav: ["topnav", "pageTitleSlot", "topnavButtonsSlot"],
  pageTitleSlot: ["pageTitleSlot"],
  topnavButtonsSlot: ["topnavButtonsSlot"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicTopnav__ArgProps,
          internalVariantPropNames: PlasmicTopnav__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicTopnav__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "topnav") {
    func.displayName = "PlasmicTopnav";
  } else {
    func.displayName = `PlasmicTopnav.${nodeName}`;
  }
  return func;
}

export const PlasmicTopnav = Object.assign(
  // Top-level PlasmicTopnav renders the root element
  makeNodeComponent("topnav"),
  {
    // Helper components rendering sub-elements
    pageTitleSlot: makeNodeComponent("pageTitleSlot"),
    topnavButtonsSlot: makeNodeComponent("topnavButtonsSlot"),
    // Metadata about props expected for PlasmicTopnav
    internalVariantProps: PlasmicTopnav__VariantProps,
    internalArgProps: PlasmicTopnav__ArgProps
  }
);

export default PlasmicTopnav;
/* prettier-ignore-end */
